import React, {useLayoutEffect} from "react";
import {useAuthDispatcher} from "../context/AuthContext";
import {actionTypes, setLoginStateDispatch} from "../context/reducer";
import {getUserRefreshToken, setUserRefreshToken} from "../service/localStorage/LocalStorageService";
import {LoginService} from "../serverService/login/LoginService";
import {showServerErrorMessage} from "@moeindal/base-raiko-panel-components";


export default function AuthorizationRoute(props) {

    const refreshToken = getUserRefreshToken()
    const dispatch = useAuthDispatcher()
    const service = new LoginService()


    useLayoutEffect(() => {
        if (typeof service !== 'undefined') {
            if (refreshToken !== null) {
                service.getUserTokenByRefreshToken(refreshToken)
                    .then(response => {
                        getAdminRolesFromServer(response.data.refresh_token, response.data.access_token)
                    }).catch(reason => {
                    dispatch({
                        type: actionTypes.LOGOUT,
                        loading: false,
                        loginState: false,
                        role: []
                    })
                })
            } else {
                dispatch({
                    type: actionTypes.LOGOUT,
                    loading: false,
                    loginState: false,
                    role: []
                })
            }
        }
    }, [dispatch, refreshToken])

    function getAdminRolesFromServer(refresh_token, access_token) {
        service.getAccessInfo(access_token)
            .then(response => {
                setUserRefreshToken(refresh_token)
                dispatch(setLoginStateDispatch(
                    actionTypes.LOGIN,
                    access_token,
                    response.permissions))
            }).catch(reason => {
            showServerErrorMessage(reason)
        })
    }

    return (<>{props.children}</>)
}